import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import TableAdminsComponent from '../components/TableAdminsComponent';
import HeaderComponent from '../components/HeaderComponent';
import { navigateTo } from '../utils/navigation';
import { validateSession } from '../utils/functions';
var config = process.env;

class LoginPage extends Component {

	constructor(){
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole
        }
	}

	async componentDidMount() {
        const role = await validateSession(true);
        if (role == 2) {
            navigateTo(config.REACT_APP_REDIRECT_BOX_GAME);
            return;
        }
        this.setState({ checked: true, role });
    }

    addAdmin = () => {
        navigateTo('/addAdmin');
    }
    
	render() {
        if (!this.state.checked) {
            return (<div></div>);
        } else {
            return (  
                <div class="container-fluid">
                    <div class="row">
                        <SidebarComponent itemSelected={7} role={this.state.role}/>
                        <main class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                            <NavbarComponent role={this.state.role} />
                            <div className="main-content-container container-fluid px-4 mb-4">
                                <HeaderComponent title="Dashboard" subtitle="Administradores"/>
                                <TableAdminsComponent />
                            </div>
                        </main>
                    </div>
                    <div onClick={() => this.addAdmin()} class="color-switcher-toggle animated pulse infinite">
                        <i class="material-icons">add</i>
                    </div>
                </div>
            );
        }
    }
}

export default LoginPage;
